module.exports = __webpack_public_path__ + "static/gg_logo-1c16091915c3aca1dea259a8a5491561.gif";